import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import myVue from "../components/myVue";
import search from "../components/search"
import MxChm from "../components/MxChm"
import login from "../components/login"
import register from "../components/register"
import resetpwd from "../components/resetpwd"
import newpwd from "../components/newpwd"
import mywork from "../components/myWork"
import workorder from "../components/workOrder"
import workinfo from "../components/workInfo"

import mxdraw_login from "../components/mxdraw_login"
import mxdraw_register from "../components/mxdraw_register"
import mxdraw_resetpwd from "../components/mxdraw_resetpwd"
import mxdraw_newpwd from "../components/mxdraw_newpwd"

import downloadList from "../components/downloadList"

import "../assets/css/mxchm.css"
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MxChm',
      component: MxChm
    },
    {
      path: '/myVue',
      name: 'MyVue',
      component: myVue
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/MxChm',
      name: 'MxChm',
      component: MxChm
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: register
    // },
    // {
    //   path: '/resetpwd',
    //   name: 'resetpwd',
    //   component: resetpwd
    // },
    // {
    //   path: '/newpwd',
    //   name: 'newpwd',
    //   component: newpwd
    // },
    {
      path: '/workorder',
      name: 'workorder',
      component: workorder
    },
    {
      path: '/mywork',
      name: 'mywork',
      component: mywork
    },
    {
      path: '/workinfo',
      name: 'workinfo',
      component: workinfo
    },
    {
      path: '/login',
      name: 'login',
      component: mxdraw_login
    },
    {
      path: '/register',
      name: 'register',
      component: mxdraw_register
    },
    {
      path: '/resetpwd',
      name: 'resetpwd',
      component: mxdraw_resetpwd
    },
    {
      path: '/newpwd',
      name: 'newpwd',
      component: mxdraw_newpwd
    },
    {
      path: '/downloadList',
      name: 'downloadList',
      component: downloadList
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js